import React, { memo } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Label,
    Form,
    FormGroup,
} from 'reactstrap';
import IntlMessages from '../../../helpers/IntlMessages';
import PerfectScrollbar from 'react-perfect-scrollbar';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import DynamicForm from '../general/DynamicForm';

const ContentComponent = ({
    title,
    isOpen,
    toggle,
    onSubmit,
    data_dynamic_form,
    values,
    setting,
    item,
    onChange,
    onChangeDynamicForm,
}) => {
    // console.log('render AddComponent');
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            wrapClassName='modal-right'
            backdrop={true}
            autoFocus={false}
        >
            <Form onSubmit={(e) => onSubmit(e)}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody className='scrool modal-right-add'>
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            wheelPropagation: false,
                        }}
                        id='modal-right__body'
                    >
                        <FormGroup className='mt-3 has-float-label'>
                            <Label for='title' className='text-muted'>
                                <IntlMessages id='todo.title' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                autoFocus={true}
                                type='text'
                                name='title'
                                id='title'
                                disabled={setting.viewonly && !setting.add}
                                value={values.title}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='description' className='text-muted'>
                                <IntlMessages id='todo.description' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                type='textarea'
                                name='description'
                                id='description'
                                disabled={setting.viewonly && !setting.add}
                                value={values.description}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <Label
                            for='momentFormatSelectDateTime'
                            className='text-muted has-float-label'
                        >
                            <IntlMessages id='todo.date-time' />
                        </Label>
                        <DatePicker
                            name='momentFormatSelectDateTime'
                            id='momentFormatSelectDateTime'
                            className='mb-3'
                            onChange={onChange}
                            selected={moment(
                                values.momentFormatSelectDateTime,
                                'YYYY-MM-DD HH:mm'
                            )}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            dateFormat='YYYY-MM-DD - HH:mm'
                            timeCaption='Giờ'
                            disabled={setting.viewonly && !setting.add}
                        />

                        <DynamicForm
                            values={values.dynamic_form}
                            data={data_dynamic_form}
                            onChange={onChangeDynamicForm}
                            disabled={setting.viewonly && !setting.add}
                        />
                    </PerfectScrollbar>
                </ModalBody>
                <ModalFooter>
                    <Button color='primary'>
                        <IntlMessages id='todo.btn-add' />
                    </Button>{' '}
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default memo(ContentComponent);
